/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralTriggerType } from './ReferralTriggerType';
import {
    ReferralTriggerTypeFromJSON,
    ReferralTriggerTypeFromJSONTyped,
    ReferralTriggerTypeToJSON,
    ReferralTriggerTypeToJSONTyped,
} from './ReferralTriggerType';

/**
 * 
 * @export
 * @interface CreateReferralRewardThresholdBody
 */
export interface CreateReferralRewardThresholdBody {
    /**
     * 
     * @type {boolean}
     * @memberof CreateReferralRewardThresholdBody
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReferralRewardThresholdBody
     */
    hidden: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateReferralRewardThresholdBody
     */
    expiration?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReferralRewardThresholdBody
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateReferralRewardThresholdBody
     */
    minPaymentRequired: number;
    /**
     * 
     * @type {ReferralTriggerType}
     * @memberof CreateReferralRewardThresholdBody
     */
    triggerType: ReferralTriggerType;
    /**
     * 
     * @type {number}
     * @memberof CreateReferralRewardThresholdBody
     */
    triggerValue?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRewardThresholdBody
     */
    triggerCopy?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRewardThresholdBody
     */
    rewardCopy?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRewardThresholdBody
     */
    qualifierCopy?: string;
    /**
     * Optional RewardConfig id granted to the referrer when the trigger fires. When set, payout runs through the generic reward distributor (any RewardType — FUEL, FUELUP_MOVES, XP, …). When empty, the legacy USD→FUEL amount is used.
     * @type {string}
     * @memberof CreateReferralRewardThresholdBody
     */
    rewardConfigId?: string;
}



/**
 * Check if a given object implements the CreateReferralRewardThresholdBody interface.
 */
export function instanceOfCreateReferralRewardThresholdBody(value: object): value is CreateReferralRewardThresholdBody {
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('minPaymentRequired' in value) || value['minPaymentRequired'] === undefined) return false;
    if (!('triggerType' in value) || value['triggerType'] === undefined) return false;
    return true;
}

export function CreateReferralRewardThresholdBodyFromJSON(json: any): CreateReferralRewardThresholdBody {
    return CreateReferralRewardThresholdBodyFromJSONTyped(json, false);
}

export function CreateReferralRewardThresholdBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralRewardThresholdBody {
    if (json == null) {
        return json;
    }
    return {
        
        'disabled': json['disabled'],
        'hidden': json['hidden'],
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'amount': json['amount'],
        'minPaymentRequired': json['minPaymentRequired'],
        'triggerType': ReferralTriggerTypeFromJSON(json['triggerType']),
        'triggerValue': json['triggerValue'] == null ? undefined : json['triggerValue'],
        'triggerCopy': json['triggerCopy'] == null ? undefined : json['triggerCopy'],
        'rewardCopy': json['rewardCopy'] == null ? undefined : json['rewardCopy'],
        'qualifierCopy': json['qualifierCopy'] == null ? undefined : json['qualifierCopy'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
    };
}

export function CreateReferralRewardThresholdBodyToJSON(json: any): CreateReferralRewardThresholdBody {
    return CreateReferralRewardThresholdBodyToJSONTyped(json, false);
}

export function CreateReferralRewardThresholdBodyToJSONTyped(value?: CreateReferralRewardThresholdBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled': value['disabled'],
        'hidden': value['hidden'],
        'expiration': value['expiration'],
        'amount': value['amount'],
        'minPaymentRequired': value['minPaymentRequired'],
        'triggerType': ReferralTriggerTypeToJSON(value['triggerType']),
        'triggerValue': value['triggerValue'],
        'triggerCopy': value['triggerCopy'],
        'rewardCopy': value['rewardCopy'],
        'qualifierCopy': value['qualifierCopy'],
        'rewardConfigId': value['rewardConfigId'],
    };
}

